import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/css/design-system.css';
import './assets/css/ott-premium-mobile.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/css/Menuscreen.css'
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { TenantProvider } from './TenantContext';
import BuildBadge from './components/BuildBadge/BuildBadge';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <TenantProvider>
            <ScrollToTop/>
            <App />
            <BuildBadge />
          </TenantProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
